/**
 * Show - Conditional rendering component
 *
 * Renders children only when the `when` condition is truthy.
 * Optionally renders a fallback when the condition is falsy.
 *
 * @module @smoothie-framework/ui/control
 *
 * @example
 * ```tsx
 * <Show when={isLoggedIn()} fallback={<LoginButton />}>
 *   <Dashboard />
 * </Show>
 * ```
 */
import { createNodeId } from '../render/node-id';
/**
 * Conditionally renders content based on a boolean or truthy value.
 *
 * This component returns a UINode descriptor that the patch pipeline
 * handles specially to provide efficient reactive updates.
 *
 * @param props.when - The condition to evaluate
 * @param props.fallback - Content to render when condition is falsy
 * @param props.children - Content to render when condition is truthy
 */
export function Show(props) {
    return {
        id: createNodeId(),
        type: 'Show',
        props,
        children: [],
    };
}
//# sourceMappingURL=Show.js.map